<template>
  <div class="content">
    <form class="form-horizontal" @submit.prevent="onSubmit">
      <card class="text-left">
        <div class="row" @paste="onSectionPaste">
          <label class="col-sm-2 col-form-label">다국어보기</label>
          <div class="col-sm-4">
            <base-switch v-model="showTranslation" type="primary" on-text="ON" off-text="OFF" />
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">타입</label>
          <div class="col-sm-10">
            <base-radio name="static" inline v-model="type">소개페이지</base-radio>
            <base-radio name="poll" inline v-model="type">투표</base-radio>
            <base-radio name="quiz" inline v-model="type">퀴즈</base-radio>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">제목(목록용)</label>
          <div class="col-sm-10">
            <base-input placeholder="제목" v-model="title">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">경로</label>
          <div class="col-sm-10">
            <base-input placeholder="경로" v-model="path">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
        <div v-if="type === 'quiz'">
          <div class="row">
            <label class="col-sm-2 col-form-label">제목</label>
            <div class="col-sm-10">
              <div class="row">
                <div class="col-sm-12">
                  <base-input placeholder="제목" v-model="titleKo">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row" v-if="showTranslation">
                <div class="col-sm-12">
                  <base-input placeholder="제목(영어)" v-model="titleEn">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row" v-if="showTranslation">
                <div class="col-sm-12">
                  <base-input placeholder="제목(일본어)" v-model="titleJa">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-form-label">노출 문제 수</label>
            <div class="col-sm-4">
              <base-input placeholder="노출 문제 수" v-model="quizCount">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
            <label class="col-sm-2 col-form-label">타이머</label>
            <div class="col-sm-4">
              <base-input placeholder="타이머" v-model="quizTimer">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
            <label class="col-sm-2 col-form-label">노출시간</label>
            <div class="col-sm-10">
              <base-input class="date-picker" placeholder="">
                <el-date-picker type="datetimerange" start-placeholder="시작일시" end-placeholder="종료일시" v-model="quizPeriod" />
              </base-input>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">한국어 이미지</label>
                <div class="col-sm-8">
                  <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileUrl" @onChangeFileIds="onFileIdChange" />
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">영어 이미지</label>
                <div class="col-sm-8">
                  <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileEnUrl" @onChangeFileIds="onFileIdEnChange" />
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">일본어 이미지</label>
                <div class="col-sm-8">
                  <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileJaUrl" @onChangeFileIds="onFileIdJaChange" />
                </div>
              </div>
            </div>
          </div>
          <div class="row"></div>
        </div>
        <div v-if="type === 'static'">
          <div class="row">
            <label class="col-sm-2 col-form-label">제목</label>
            <div class="col-sm-10">
              <div class="row">
                <div class="col-sm-12">
                  <base-input placeholder="제목" v-model="titleKo">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row" v-if="showTranslation">
                <div class="col-sm-12">
                  <base-input placeholder="제목(영어)" v-model="titleEn">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row" v-if="showTranslation">
                <div class="col-sm-12">
                  <base-input placeholder="제목(일본어)" v-model="titleJa">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-form-label">내용</label>
            <div class="col-sm-10">
              <div class="row">
                <div class="col-sm-12">
                  <textarea class="form-control" id="content" rows="30" v-model="bodyKo" />
                </div>
              </div>
              <div class="row" v-if="showTranslation">
                <div class="col-sm-12">
                  <textarea class="form-control" id="content" rows="30" v-model="bodyEn" />
                </div>
              </div>
              <div class="row" v-if="showTranslation">
                <div class="col-sm-12">
                  <textarea class="form-control" id="content" rows="30" v-model="bodyJa" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-form-label">버튼명</label>
            <div class="col-sm-3">
              <base-input placeholder="버튼명" v-model="buttonName">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
            <div class="col-sm-3">
              <base-input placeholder="버튼명 영어" v-model="buttonNameEn">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
            <div class="col-sm-3">
              <base-input placeholder="버튼명 일본어" v-model="buttonNameJa">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-form-label">버튼링크</label>
            <div class="col-sm-10">
              <base-input placeholder="버튼링크" v-model="buttonLink">
                <span slot="helpBlock" class="form-text" />
              </base-input>
            </div>
          </div>

          <div class="row">
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">한국어 이미지</label>
                <div class="col-sm-8">
                  <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileUrl" @onChangeFileIds="onFileIdChange" />
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">영어 이미지</label>
                <div class="col-sm-8">
                  <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileEnUrl" @onChangeFileIds="onFileIdEnChange" />
                </div>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="row">
                <label class="col-sm-4 col-form-label">일본어 이미지</label>
                <div class="col-sm-8">
                  <BlipFileUploadZone :upload-category="6" :maxFiles="1" :fileUrl="imageFileJaUrl" @onChangeFileIds="onFileIdJaChange" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <label class="col-sm-2 col-form-label">상세설명</label>
            <div class="col-sm-8">
              <base-input placeholder="상세설명">
                <textarea class="form-control" rows="10" v-model="descriptionKo"></textarea>
              </base-input>
            </div>
          </div>
          <div class="row" v-if="showTranslation">
            <label class="col-sm-2 col-form-label"></label>
            <div class="col-sm-8">
              <base-input placeholder="상세설명">
                <textarea class="form-control" rows="10" v-model="descriptionEn"></textarea>
              </base-input>
            </div>
          </div>
          <div class="row" v-if="showTranslation">
            <label class="col-sm-2 col-form-label"></label>
            <div class="col-sm-8">
              <base-input placeholder="상세설명">
                <textarea class="form-control" rows="10" v-model="descriptionJa"></textarea>
              </base-input>
            </div>
          </div>
        </div>
        <div v-if="type === 'poll' || type === 'quiz'" class="mt-4">
          <div v-for="(quiz, quizIndex) in quizs" :key="quizIndex" class="row">
            <div class="col-sm-12">
              <div class="row">
                <label class="col-sm-2 col-form-label">질문 {{ quizIndex + 1 }} 타입</label>
                <div class="col-sm-10">
                  <base-radio name="text" inline v-model="quiz.questionType">Text</base-radio>
                  <base-radio name="image" inline v-model="quiz.questionType">Image</base-radio>
                  <base-radio name="youtube" inline v-model="quiz.questionType">Youtube Embed</base-radio>
                </div>
              </div>
              <div v-if="quiz.questionType === 'image'" class="row mb-2">
                <label class="col-sm-2 col-form-label">이미지 (최대 4개)</label>
                <div class="col-sm-10">
                  <div class="row">
                    <div v-for="(imageField, imageFieldIndex) in 4" :key="imageFieldIndex" class="col-sm-3 h-100">
                      <div>
                        <div style="position: relative">
                          <BlipFileUploadZone
                            :ref="`quizThumbnail${imageFieldIndex}`"
                            :upload-category="2"
                            :maxFiles="1"
                            :fileUrl="getQuizThumbnail(quiz.questionImage, imageFieldIndex)"
                            @onChangeFileIds="(newFileIds) => onQuestionFileIdChange(newFileIds, quizIndex, imageFieldIndex)"
                          />
                        </div>
                        <base-input
                          placeholder="사진 캡션"
                          class="mt-2"
                          :value="getQuizCaption(quizIndex, imageFieldIndex)"
                          @input="updateQuizCaption(quizIndex, imageFieldIndex, $event)"
                        >
                          <span slot="helpBlock" class="form-text" />
                        </base-input>
                        <base-input
                          placeholder="사진 캡션(영어)"
                          class="mt-2"
                          :value="getQuizCaption(quizIndex, imageFieldIndex, 'En')"
                          @input="updateQuizCaption(quizIndex, imageFieldIndex, $event, 'En')"
                        >
                          <span slot="helpBlock" class="form-text" />
                        </base-input>
                        <base-input
                          placeholder="사진 캡션(일본어)"
                          class="mt-2"
                          :value="getQuizCaption(quizIndex, imageFieldIndex, 'Ja')"
                          @input="updateQuizCaption(quizIndex, imageFieldIndex, $event, 'Ja')"
                        >
                          <span slot="helpBlock" class="form-text" />
                        </base-input>
                        <button type="button" class="btn btn-sm" @click="deleteQuizThumbnail(quizIndex, imageFieldIndex)">이미지 비우기</button>
                      </div>
                    </div>
                  </div>
                  <p class="text-muted">* 이미지의 비율은 16:9의 비율을 권장합니다.</p>
                </div>
              </div>
              <div v-if="quiz.questionType === 'youtube'" class="row">
                <label class="col-sm-2 col-form-label">유튜브 링크</label>
                <div class="col-sm-10">
                  <base-input placeholder="유튜브 링크" v-model="quiz.questionYoutubeLink">
                    <span slot="helpBlock" class="form-text" />
                  </base-input>
                </div>
              </div>
              <div class="row">
                <label class="col-sm-2 col-form-label">질문 {{ quizIndex + 1 }}</label>
                <div class="col-sm-4">
                  <div class="row">
                    <div class="col-sm-12">
                      <base-input placeholder="질문" v-model="quiz.question">
                        <span slot="helpBlock" class="form-text" />
                      </base-input>
                    </div>
                  </div>
                  <div class="row" v-if="showTranslation">
                    <div class="col-sm-12">
                      <base-input placeholder="질문(영어)" v-model="quiz.questionEn">
                        <span slot="helpBlock" class="form-text" />
                      </base-input>
                    </div>
                  </div>
                  <div class="row" v-if="showTranslation">
                    <div class="col-sm-12">
                      <base-input placeholder="질문(일본어)" v-model="quiz.questionJa">
                        <span slot="helpBlock" class="form-text" />
                      </base-input>
                    </div>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-sm-3">
                      <base-radio name="M" v-model="quiz.type">객관식</base-radio>
                      <base-radio name="S" v-if="type === 'poll'" v-model="quiz.type">주관식</base-radio>
                    </div>
                    <div class="col-sm-3">
                      <base-checkbox v-model="quiz.showApp">앱</base-checkbox>
                      <base-checkbox v-model="quiz.showWeb">웹</base-checkbox>
                    </div>
                    <div class="col-sm-4">
                      <div class="row">
                        <div class="col-sm-6">
                          <base-button @click="addQuiz">+</base-button>
                        </div>
                        <div class="col-sm-6">
                          <base-button type="warning" @click="deleteQuiz(quizIndex)">-</base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row" v-if="type === 'poll'">
                    <div class="col-sm-12">
                      <div class="row">
                        <div class="col-sm-2 col-form-label">최소답변</div>
                        <div class="col-sm-4">
                          <base-input placeholder="답변개수" v-model="quiz.minSelection">
                            <span slot="helpBlock" class="form-text" />
                          </base-input>
                        </div>
                        <div class="col-sm-2 col-form-label">최대답변</div>
                        <div class="col-sm-4">
                          <base-input placeholder="답변개수" v-model="quiz.maxSelection">
                            <span slot="helpBlock" class="form-text" />
                          </base-input>
                        </div>
                        <div class="col-sm-2 col-form-label">대시보드</div>
                        <div class="col-sm-4">
                          <el-select class="select-primary" size="large" placeholder="대시보드노출" v-model="quiz.dashboardType">
                            <el-option
                              v-for="option in dashboardTypes"
                              class="select-primary"
                              :value="option.type"
                              :label="option.name"
                              :key="option.type"
                            ></el-option>
                          </el-select>
                        </div>
                        <template v-if="dashboardTypeHasArtistId(quiz.dashboardType)">
                          <div class="col-sm-2 col-form-label">아티스트</div>
                          <div class="col-sm-4">
                            <v-select
                              class="select-primary"
                              size="large"
                              placeholder="아티스트선택"
                              :clearable="false"
                              :options="quiz.artists"
                              label="label"
                              v-model="quiz.dashboardMetadata"
                              @search="(query) => fetchArtists(query, quiz)"
                            >
                            </v-select>
                          </div>
                        </template>
                        <template v-if="dashboardTypeHasAlbumId(quiz.dashboardType)">
                          <div class="col-sm-2 col-form-label">앨범</div>
                          <div class="col-sm-4">
                            <v-select
                              class="select-primary"
                              size="large"
                              placeholder="앨범선택"
                              :clearable="false"
                              :options="quiz.albums"
                              label="label"
                              v-model="quiz.dashboardMetadata"
                              @search="(query) => fetchAlbums(query, quiz)"
                            >
                            </v-select>
                          </div>
                        </template>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <base-radio name="artist" inline v-model="quiz.answerType">멤버 불러오기</base-radio>
                        </div>
                        <div v-if="quiz.answerType === 'artist'" class="col-sm-3">
                          <ArtistSelect
                            :currentIndex="quizIndex"
                            @unitChangeEvent="getArtistInfo"
                            :show-title="false"
                            :show-all-units="false"
                            :show-members="false"
                          />
                        </div>
                        <div v-if="quiz.answerType === 'artist'" class="col-sm-3">
                          <base-button @click="loadMember(quizIndex)">불러오기</base-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="quiz.type === 'M'">
                <div class="col-sm-12">
                  <div class="col-sm-12" style="overflow-x: auto; white-space: nowrap">
                    <draggable handle=".handle" v-model="quiz.answers" group="people" @start="drag = true" @end="drag = false">
                      <div
                        v-for="(answer, answerIndex) in quiz.answers"
                        :key="answerIndex"
                        style="display: inline-block; width: 200px; margin-right: 10px; vertical-align: top"
                      >
                        <label class="col-form-label handle">답변 {{ answerIndex + 1 }}</label>
                        <div class="mb-2">
                          <BlipFileUploadZone
                            class="quiz-answer-image"
                            style="max-height: 140px"
                            :upload-category="6"
                            :maxFiles="1"
                            :fileUrl="answer.imageFileId | blipImageUrl"
                            @onChangeFileIds="(ids) => onImageFileIdsChange(ids, answer, 'imageFileId')"
                          />
                        </div>
                        <base-input placeholder="답변" v-model="answer.answer" class="mb-2">
                          <span slot="helpBlock" class="form-text" />
                        </base-input>
                        <base-input placeholder="답변(영어)" v-model="answer.answerEn" v-if="showTranslation" class="mb-2">
                          <span slot="helpBlock" class="form-text" />
                        </base-input>
                        <base-input placeholder="답변(일본어)" v-model="answer.answerJa" v-if="showTranslation" class="mb-2">
                          <span slot="helpBlock" class="form-text" />
                        </base-input>
                        <base-input placeholder="아티스트아이디" v-if="quiz.answerType === 'artist'" v-model="answer.artistId" class="mb-2">
                          <span slot="helpBlock" class="form-text" />
                        </base-input>
                        <div v-if="type === 'quiz'">
                          <base-checkbox v-model="answer.checked">정답</base-checkbox>
                        </div>
                        <div class="mt-1">
                          <base-button @click="addAnswer(quizIndex)">+</base-button>
                          <base-button type="warning" @click="deleteAnswer(quizIndex, answerIndex)">-</base-button>
                        </div>
                      </div>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-2 col-form-label">노출여부</label>
          <div class="col-sm-4">
            <base-switch v-model="isVisible" type="primary" on-text="ON" off-text="OFF" />
          </div>
        </div>
      </card>
      <base-button native-type="submit" v-if="id != null" type="success">수정</base-button>
      <base-button native-type="submit" v-else type="success">등록</base-button>
      <base-button @click="goBack" type="default">취소</base-button>
    </form>
  </div>
</template>
<script>
import { BaseInput, BaseSwitch, Card } from "@/components/index";
import { Toast } from "@/util/Toast";
import BlipFileUploadZone from "@/components/BlipFileUploadZone.vue";
import * as _ from "lodash";
import { DashboardType } from "@/pages/Quest/Site/DashboardType";
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";

import draggable from "vuedraggable";
export default {
  components: {
    draggable,
    ArtistSelect,
    BaseSwitch,
    BlipFileUploadZone,
    Card,
    BaseInput,
  },
  async created() {
    if (this.$route.query.id) {
      this.id = Number(this.$route.query.id);
      await this.getSiteById();
    } else {
      this.addQuiz();
    }
  },

  watch: {
    quizs: {
      handler(newQuizs) {
        newQuizs.forEach((quiz) => {
          this.$watch(
            () => quiz.dashboardType,
            (newVal) => {
              const hasAlbumId = this.dashboardTypeHasAlbumId(newVal);
              if (hasAlbumId) {
                quiz.dashboardMetadata = this.quizs[0].dashboardMetadata;
                this.$forceUpdate();
              }
            }
          );
        });
      },
      immediate: true,
      deep: true,
    },
  },

  data() {
    return {
      dashboardTypes: DashboardType,
      showTranslation: true,
      type: "static",
      id: null,
      title: null,
      imageFileId: null,
      imageFileUrl: null,
      imageFileEnId: null,
      imageFileEnUrl: null,
      imageFileJaId: null,
      imageFileJaUrl: null,
      titleKo: null,
      titleEn: null,
      titleJa: null,
      bodyKo: null,
      bodyEn: null,
      bodyJa: null,
      descriptionKo: null,
      descriptionEn: null,
      descriptionJa: null,
      quizCount: null,
      quizTimer: null,
      quizPeriod: [],
      quizs: [],
      path: null,
      buttonLink: null,
      buttonName: null,
      buttonNameEn: null,
      buttonNameJa: null,
      isVisible: false,
      description: null,
    };
  },

  methods: {
    getArtistInfo(param) {
      this.quizs[param.currentIndex]["unitId"] = param.unitId;
    },
    onImageFileIdsChange(newFileIds, answer, fileId) {
      answer[fileId] = newFileIds[0];
    },
    async loadMember(index) {
      const unitId = this.quizs[index]["unitId"];
      const res = await this.$axios.get(`/artistUnit/${unitId}/memberNames`);
      const names = res.data.data;

      const grouped = Object.values(
        names.reduce((acc, { artistId, code, name }) => {
          if (!acc[artistId]) acc[artistId] = { artistId, names: [] };
          acc[artistId][code] = name;
          return acc;
        }, {})
      );
      const answers = this.quizs[index]["answers"];
      for (let i = 0; i < grouped.length; i++) {
        if (!answers[i]) {
          answers.push({
            artistId: grouped[i].artistId,
            answer: grouped[i].ko,
            answerEn: grouped[i].en,
            answerJa: grouped[i].ja,
          });
        } else if (answers[i]) {
          answers[i] = {
            artistId: grouped[i].artistId,
            answer: grouped[i].ko,
            answerEn: grouped[i].en,
            answerJa: grouped[i].ja,
          };
        }
      }

      this.$forceUpdate();
    },
    async fetchAlbums(query, quiz) {
      if (!query) {
        quiz.albums = [];
        return;
      }
      await this.$axios
        .get(`/albums?name=${query}`)
        .then((response) => {
          quiz.albums = response.data.data.map((album) => ({
            label: `${album.albumName}(${album.artistName})`,
            value: album.albumId,
            artistId: album.artistId,
            albumId: album.albumId,
          }));
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          quiz.albumLoading = false;
        });
    },
    async fetchArtists(query, quiz) {
      if (!query) {
        quiz.artists = [];
        return;
      }
      await this.$axios
        .get(`/artists?name=${query}`)
        .then((response) => {
          quiz.artists = response.data.data.map((artist) => ({
            label: `${artist.name}(${artist.id})`,
            value: artist.id,
            artistId: artist.id,
          }));
        })
        .catch((err) => {
          console.log(err);
        });
    },
    dashboardTypeHasAlbumId(type) {
      const selected = this.dashboardTypes.find((d) => d.type === type);
      return selected?.filter?.includes("albumId");
    },
    dashboardTypeHasArtistId(type) {
      const selected = this.dashboardTypes.find((d) => d.type === type);
      return selected?.filter?.includes("artistId");
    },
    onFileIdChange(newFileIds) {
      this.imageFileId = newFileIds[0];
    },
    onFileIdEnChange(newFileIds) {
      this.imageFileEnId = newFileIds[0];
    },
    onFileIdJaChange(newFileIds) {
      this.imageFileJaId = newFileIds[0];
    },
    onQuestionFileIdChange(newFileIds, index, imageFieldIndex) {
      const currentImage = this.quizs[index]?.questionImage;
      if (currentImage) {
        const existingImageIndex = currentImage.findIndex((img) => img.idx === imageFieldIndex);
        if (existingImageIndex !== -1) {
          // 해당 idx의 이미지가 이미 존재하면 업데이트
          this.quizs[index].questionImage[existingImageIndex] = {
            ...currentImage[existingImageIndex],
            image: newFileIds[0],
          };
        } else {
          // 해당 idx의 이미지가 없으면 새로 추가
          this.quizs[index].questionImage.push({
            idx: imageFieldIndex,
            image: newFileIds[0],
            caption: "",
            captionEn: "",
            captionJa: "",
          });
        }
      } else {
        this.quizs[index].questionImage = [
          {
            idx: imageFieldIndex,
            image: newFileIds[0],
            caption: "",
            captionEn: "",
            captionJa: "",
          },
        ];
      }
    },
    onConvertToYoutubeEmbed(url) {
      if (!url) return "";

      // 이미 임베드 형식인 경우 그대로 반환
      if (url.startsWith("https://www.youtube.com/embed/")) {
        return url;
      }

      try {
        let videoId = "";
        let params = "";

        if (url.includes("youtu.be/")) {
          const urlParts = url.split("youtu.be/")[1].split("?");
          videoId = urlParts[0];
          if (urlParts[1]) {
            const urlParams = new URLSearchParams(urlParts[1]);
            if (urlParams.has("t")) {
              urlParams.set("start", urlParams.get("t"));
              urlParams.delete("t");
            }
            params = `?${urlParams.toString()}`;
          }
        } else if (url.includes("youtube.com/watch?v=")) {
          const urlParams = new URLSearchParams(url.split("?")[1]);
          videoId = urlParams.get("v");
          urlParams.delete("v");
          if (urlParams.has("t")) {
            urlParams.set("start", urlParams.get("t"));
            urlParams.delete("t");
          }
          params = urlParams.toString() ? `?${urlParams.toString()}` : "";
        }

        return `https://www.youtube.com/embed/${videoId}${params}`;
      } catch (e) {
        console.error("유튜브 URL 변환 중 오류 발생:", e);
        return url;
      }
    },
    async getSiteById() {
      const res = await this.$axios.get(`/quests/sites/${this.id}`);
      this.mappingData(res.data.data.site, res.data.data.quizs);
    },

    addQuiz() {
      this.quizs.push({
        questionType: "text",
        questionYoutubeLink: null,
        questionImage: [],
        question: null,
        count: 1,
        answers: [{ answer: null }],
        albumId: null,
        dashboardType: null,
        albums: [],
        artists: [],
      });
    },

    addAnswer(index) {
      if (!this.quizs[index].answers) {
        this.quizs[index].answers = [];
      }
      this.quizs[index].answers.push({ answer: null, checked: false });
      this.$forceUpdate();
    },

    deleteQuiz(index) {
      if (this.quizs.length === 1) {
        Toast.error("최소 하나의 질문은 있어야합니다");
        return;
      }
      this.quizs.splice(index, 1);
      this.$forceUpdate();
    },

    deleteAnswer(quizIndex, answerIndex) {
      if (this.quizs[quizIndex].answers.length === 1) {
        Toast.error("최소 하나의 답변은 있어야합니다");
        return;
      }
      this.quizs[quizIndex].answers.splice(answerIndex, 1);
    },

    async onSubmit() {
      if (!this.title) {
        Toast.error("제목을 입력해주세요");
        return;
      }

      if (!this.path) {
        Toast.error("경로를 입력해주세요");
        return;
      }
      const pathRegex = /^[a-zA-Z0-9_]+$/;
      if (!pathRegex.test(this.path)) {
        Toast.error("공백과 특수문자를 제외하고 영문과 숫자, _만 입력해 주세요");
        return;
      }
      if (this.type === "poll" || this.type === "quiz") {
        if (this.quizs.length === 0) {
          Toast.error("질문이 적어도 하나 존재해야합니다");
          return;
        }
        for (const quiz of this.quizs) {
          if (
            (quiz.question && quiz.question.includes("$title")) ||
            (quiz.questionEn && quiz.questionEn.includes("$title")) ||
            (quiz.questionJa && quiz.questionJa.includes("$title"))
          ) {
            Toast.error("질문 내용에 '$title' 문구를 사용할 수 없습니다");
            return;
          }
          if (quiz.questionType === "image") {
            if (quiz.questionImage.length === 0) {
              Toast.error("이미지를 등록해주세요");
              return;
            }
            if (quiz.questionImage.length > 4) {
              Toast.error("이미지는 최대 4개까지 등록할 수 있습니다");
              return;
            }
            if (quiz.questionImage.length === 3) {
              Toast.error("이미지는 1,2,4개까지 등록할 수 있습니다");
              return;
            }
          } else if (quiz.questionType === "youtube") {
            if (!quiz.questionYoutubeLink) {
              Toast.error("유튜브 링크를 입력해주세요");
              return;
            }
          }
          if (quiz.question === "" || !quiz.question) {
            Toast.error("질문을 입력해주세요");
            return;
          }
          if (!quiz.showApp && !quiz.showWeb) {
            Toast.error("노출 영역(앱 /웹)을 선택해 주세요");
            return;
          }
          if (quiz.dashboardType !== null && quiz.dashboardMetadata === undefined) {
            Toast.error("해당하는 앨범을 입력해 주세요");
            return;
          }
          for (const answer of quiz.answers) {
            if (answer.length === 0) {
              Toast.error("답변은 적어도 하나이상 입력해주세요");
              return;
            }
            if (quiz.type === "M" && (!answer.answer || answer.answer === "")) {
              Toast.error("답변을 입력해주세요");
              return;
            }
          }
          if (quiz.type === "M" && quiz.minSelection !== "" && quiz.minSelection != null && quiz.maxSelection === "" && quiz.maxSelection != null) {
            Toast.error("답변수를 입력해주세요");
            return;
          }
        }
      }
      const params = {
        type: this.type,
        quizs: this.quizs.map((q) => {
          return {
            ...q,
            questionYoutubeLink: this.onConvertToYoutubeEmbed(q.questionYoutubeLink),
          };
        }),
        title: this.title,
        titles: JSON.stringify([
          { lang: "ko", title: this.titleKo },
          { lang: "en", title: this.titleEn },
          { lang: "ja", title: this.titleJa },
        ]),
        bodies: JSON.stringify([
          { lang: "ko", body: this.bodyKo },
          { lang: "en", body: this.bodyEn },
          { lang: "ja", body: this.bodyJa },
        ]),
        imageFileId: this.imageFileId,
        imageFileEnId: this.imageFileEnId,
        imageFileJaId: this.imageFileJaId,
        quizTimer: parseInt(this.quizTimer, 10),
        quizCount: parseInt(this.quizCount, 10),
        quizPeriod: this.quizPeriod,
        path: this.path,
        point: this.point,
        star: this.star,
        superblipPoint: this.superblipPoint,
        superblipStar: this.superblipStar,
        descriptions: JSON.stringify([
          { lang: "ko", description: this.descriptionKo },
          { lang: "en", description: this.descriptionEn },
          { lang: "ja", description: this.descriptionJa },
        ]),
        isVisible: this.isVisible ? 1 : 0,
        button: JSON.stringify({ link: this.buttonLink, name: this.buttonName, nameEn: this.buttonNameEn, nameJa: this.buttonNameJa }),
      };
      try {
        if (this.id) {
          await this.$axios.put(`/quests/sites/${this.id}`, params).then(() => {
            Toast.success("수정되었습니다");
            this.$router.go(-1);
          });
        } else {
          await this.$axios.post(`/quests/sites`, params).then(() => {
            Toast.success("등록되었습니다");
            this.$router.go(-1);
          });
        }
      } catch (e) {
        Toast.error("중복된 경로가 존재합니다");
      }
    },
    goBack() {
      history.go(-1);
    },
    mappingData(site, quizs) {
      const data = site;
      this.title = data.title;
      this.type = data.type;
      this.path = data.path;
      const quizMetadata = data.quizMetadata;
      if (quizMetadata) {
        this.quizTimer = quizMetadata.timer;
        this.quizCount = quizMetadata.count;
        this.quizPeriod = quizMetadata.period;
      }
      const button = data.button;
      if (button) {
        const json = JSON.parse(button);
        this.buttonLink = json.link;
        this.buttonName = json.name;
        this.buttonNameEn = json.nameEn;
        this.buttonNameJa = json.nameJa;
      }
      this.imageFileId = data.imageFileId;
      this.imageFileEnId = data.imageFileEnId;
      this.imageFileJaId = data.imageFileJaId;
      if (data.titles) {
        const json = JSON.parse(data.titles);
        this.titleKo = _.find(json, { lang: "ko" }).title;
        this.titleEn = _.find(json, { lang: "en" }).title;
        this.titleJa = _.find(json, { lang: "ja" }).title;
      }
      if (data.bodies) {
        const json = JSON.parse(data.bodies);
        this.bodyKo = _.find(json, { lang: "ko" }).body;
        this.bodyEn = _.find(json, { lang: "en" }).body;
        this.bodyJa = _.find(json, { lang: "ja" }).body;
      }
      if (data.descriptions) {
        const json = JSON.parse(data.descriptions);
        this.descriptionKo = _.find(json, { lang: "ko" }).description;
        this.descriptionEn = _.find(json, { lang: "en" }).description;
        this.descriptionJa = _.find(json, { lang: "ja" }).description;
      }
      if (this.imageFileId) {
        this.imageFileUrl = window.Endpoints.imageServerUrl + this.imageFileId;
      }
      if (this.imageFileEnId) {
        this.imageFileEnUrl = window.Endpoints.imageServerUrl + this.imageFileEnId;
      }
      if (this.imageFileJaId) {
        this.imageFileJaUrl = window.Endpoints.imageServerUrl + this.imageFileJaId;
      }

      this.isVisible = data.isVisible === 1;

      if (this.type === "poll" || this.type === "quiz") {
        this.quizs = quizs.map((quiz) => ({
          ...quiz,
          albums: [],
          artists: [],
        }));
      }
    },
    onSectionPaste(e) {
      // Stop data actually being pasted into div
      e.stopPropagation();
      e.preventDefault();

      const pastedData = e.clipboardData.getData("text");

      try {
        const json = JSON.parse(pastedData);
        if (typeof json === "object") {
          this.mappingData(json.site, json.quizs);
        } else {
          window.Toast.error("잘못된 데이터입니다");
        }
      } catch (e) {
        window.Toast.error("잘못된 데이터입니다");
      }
    },
    getQuizThumbnail(currentQuizImage, imageIndex) {
      const image = currentQuizImage?.find((img) => img.idx === imageIndex)?.image;
      if (!image) return null;
      return window.Endpoints.imageServerUrl + image;
    },
    deleteQuizThumbnail(quizIndex, imageIndex) {
      this.$refs[`quizThumbnail${imageIndex}`][0].$refs.dropzone.removeAllFiles(); //현재 이미지 파일 지우기

      const quiz = { ...this.quizs[quizIndex] };
      const questionImage = [...quiz.questionImage];

      // imageIndex와 일치하는 idx를 가진 항목의 인덱스를 찾아서 제거
      const removeIndex = questionImage.findIndex((img) => img.idx === imageIndex);
      if (removeIndex !== -1) {
        questionImage.splice(removeIndex, 1);
        this.$set(quiz, "questionImage", questionImage);
        this.$set(this.quizs, quizIndex, quiz);
      }
    },
    getQuizCaption(quizIndex, imageIndex, lang) {
      const image = this.quizs[quizIndex]?.questionImage?.find((img) => img.idx === imageIndex);
      if (!image) return "";
      if (lang) {
        return image[`caption${lang}`] || "";
      }
      return image?.caption || "";
    },
    updateQuizCaption(quizIndex, imageIndex, value, lang) {
      const quiz = { ...this.quizs[quizIndex] };
      const questionImage = [...quiz.questionImage];

      let imageItem = questionImage.find((img) => img.idx === imageIndex);
      if (!imageItem) {
        imageItem = {
          idx: imageIndex,
          image: null,
          caption: "",
          captionEn: "",
          captionJa: "",
        };
        questionImage.push(imageItem);
      }

      if (lang) {
        imageItem[`caption${lang}`] = value;
      } else {
        imageItem.caption = value;
      }

      this.$set(quiz, "questionImage", questionImage);
      this.$set(this.quizs, quizIndex, quiz);
    },
  },
};
</script>
<style lang="scss">
//.quiz-answer-image .vue-dropzone .dz-preview .dz-image {
//  height: 120px !important;
//}
.quiz-answer-image .vue-dropzone .dz-message .subtitle {
  display: none;
}
</style>
